module.exports = __webpack_public_path__ + "img/bullet-list.ff2d3d11.svg";